import React from 'react';
import { Grid, Typography } from '@material-ui/core';

const CardInstituicoes = ({ image, tittle, subtittle }) => {
    return (
        <Grid
            container
            justify="center"
            alignItems="flex-start"
            style={{
                backgroundColor: '#FFFFFF',
                width: '330px',
                height: '276px',
                borderRadius: '8px',
                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                padding: '16px',
                boxSizing: 'border-box',
                overflow: 'hidden',
                boxShadow: 'none'
            }}
        >

            <img src={image} alt="Imagem" style={{ width: '115%', height: 'auto', marginTop: '-16px' }} />

            <Typography variant="h5" gutterBottom style={{ fontFamily: 'Public Sans', fontWeight: '600', fontSize: '24px', lineHeight: '24px', alignItems: 'center', width:'80%', textAlign:'center' }}>
                {tittle}
            </Typography>
            <Typography variant="body1" style={{ fontFamily: 'Public Sans', fontWeight: '400', fontSize: '14px', lineHeight: '24px', alignItems: 'center' }}>
                {subtittle}
            </Typography>
        </Grid>
    );
}

export default CardInstituicoes;
